import React, { useContext } from 'react'
import { Box, Container } from '@material-ui/core'
import { ThemeContext } from 'styled-components'
import logo_image from '../../assets/images/logo.png'
// import styled from 'styled-components'
// import { NavLink } from 'react-router-dom'


export default function Footer() {
    return (
        <div className="home-footer">
            <div className=" bottom-0 w-full fixed bg-[#000] z-40 flex items-center justify-center space-x-[5.5625rem] py-7 md:py-3">
                <a href="https://twitter.com/Dooarofficial" target="_blank" rel="noreferrer">
                    <img src="/images/twitter.svg" width="33" height="22" alt="twitter" />
                </a>
                <a target="_blank" href="/agreement/index.html">
                    <img src="/images/help.svg" width="33" height="22" alt="help" />
                </a>
            </div>
        </div>
    )
}

